import { render, staticRenderFns } from "./excel.vue?vue&type=template&id=35cd5112&scoped=true&"
import script from "./excel.vue?vue&type=script&lang=js&"
export * from "./excel.vue?vue&type=script&lang=js&"
import style0 from "./excel.vue?vue&type=style&index=0&id=35cd5112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd5112",
  null
  
)

export default component.exports